import Mode, { InfraStoresOfMode } from '@app/modes/Mode';
import useInfraStores from '@app/hooks/useInfraStores';

export default function useTheme<TMode extends Mode<any> = Mode>(): InfraStoresOfMode<TMode>['themeStore']['theme'] {
  const content = useInfraStores<Mode>();
  return content.themeStore.theme;
}
